import {HEADER_STICKY_ID} from 'components/Header/BasicHeader/constants';
import {FC, ReactNode, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';

interface IProps {
    children: ReactNode;
}

export const HeaderStickyPortal: FC<IProps> = ({children}) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) {
        return null;
    }

    const portalRoot = document.getElementById(HEADER_STICKY_ID);

    if (!portalRoot) {
        return null;
    }

    return ReactDOM.createPortal(children, portalRoot);
};
